import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import ConfirmarOperacionSolicitud from "./ConfirmarOperacionSolicitud";
import { trackPromise } from 'react-promise-tracker';
import TarjetaCreditoSocio from "../../generico/Tarjeta/TarjetaCreditoSocio"
import LimiteTarjetaCredito from "../../generico/Tarjeta/LimiteTarjetaCredito"
import CampoNroTelefono from "../../generico/CampoNroTelefono"
// import InputRange from 'react-input-range';
import Slider from '@mui/material/Slider';
import SolicitudesService from "../../../services/solicitudes/SolicitudesService";
import Popup from "react-popup";
import { formatoSeparadorMilesValue, phoneNumberValido, phoneFormatter, splitImporte } from "../../generico/utils/FormatoInput";
// import "react-input-range/lib/css/index.css"
import $ from "jquery";
import MensajeUsuario from "../../generico/MensajeUsuario";
import DatosSocio from "../../generico/DatosSocio"
import { mensajeExito } from '../../generico/MensajeSistemaToast';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp, faPaperPlane  } from "@fortawesome/free-solid-svg-icons";
const tokenActivo = sessionStorage.getItem('tieneToken');
export default class AumentoTC extends Component {

  constructor(props) {
    super(props);

    this.state = {
      value:  0,
      itemsConfirm: [],
      tcSocio: [],
      tipo: undefined,
      descripcion: undefined,
      limite: undefined,
      telefono: undefined,
      phoneFormat: undefined,
      montoLimInf: undefined,
      email: undefined,
      tcOriginal: undefined,
      limiteCompra: undefined,
      limiteSuperior: 30000000,
      numeroTarjeta: undefined,
    };
  }

  enviar = () => {

    var _itemsConfirm = [
      { concepto: "Tarjeta", valor: this.state.descripcion },
      { concepto: "Límite de Crédito Actual", valor: formatoSeparadorMilesValue(this.state.limiteCompra) + " Gs." },
      { concepto: "Nuevo Límite de Crédito", valor: formatoSeparadorMilesValue(this.state.monto) + " Gs." },
      { concepto: "Telefono de Contacto", valor: this.state.phoneFormat },

    ];
    if (this.state.email !== undefined && this.state.email !== "")
      _itemsConfirm.push({ concepto: "Correo Electrónico", valor: this.state.email })

    this.setState({ itemsConfirm: _itemsConfirm });
    this.modalCtrlConfirm.click();
  }
  loadDataConfirm() {
    $.validator.setDefaults({
      submitHandler: () => {
        this.enviar();

      }
    });
    $("#idTCForm").submit(function (e) {

      e.preventDefault();
      $.validator.addMethod(
        "prefijos",
        function (value, element) {

          return phoneNumberValido(element.value);

        }
      );
      $.validator.addMethod(
        "prefijoMin",
        function (value, element) {
          var tam = phoneFormatter(element.value)
          if (tam.length < 10)
            return false
          return true;

        }
      );
      var data = {};
      var dataArray = $('#idTCForm').serializeArray();

      for (var i = 0; i < dataArray.length; i++) {
        data[dataArray[i].name] = dataArray[i].value;
        if (dataArray[i].name === "tipo" && dataArray[i].value === "") {
          e.target[0].classList.add("error")
          e.target[0].classList.add("is-invalid")

          e.target[0].name = "tc"
          e.target[0].classList.add("is-invalid")
          var prueba = document.getElementById('prueba')
          prueba.classList.add("prueba")

        }
        if (dataArray[i].name === "tipo" && dataArray[i].value !== "") {
          e.target[0].name = ""
          var prueba = document.getElementById('prueba')
          prueba.classList.remove("prueba")
        }

      }

    }).validate(
      {
        rules: {
          tc: {
            required: true,

          },
          telefono: {
            required: true,
            prefijos: { prefijos: false },
            prefijoMin: { prefijoMin: false },
          },
          monto: {
            required: true,
          },
          correo: {
            email: true,
          },

        },
        messages: {
          tc: {
            required: "Este campo es requerido",
          },
          telefono: {
            required: "Este campo es requerido",
            prefijos: "Número inválido",
            prefijoMin: "Número inválido",
          },
          monto: {
            required: "Este campo es requerido",
          },
          correo: {
            email: "Email inválido",
          },
        },
        errorElement: "span",
        errorPlacement: function (error, element) {
          error.addClass("invalid-feedback");
          $(element).addClass("is-invalid");
          element.closest(".form-group").append(error);
        },

        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass("is-invalid");
        },
      });


  }

  componentDidMount() {

    if (sessionStorage.getItem("msg") !== null) {
      mensajeExito("Solicitud de Aumento de Línea Tarjeta de Crédito enviada con éxito.");
      sessionStorage.removeItem("msg")
    }
    this.setState({ tcSocio: this.obtenerTC() });

  }

  obtenerTC = () => {
    var tarjetas = [];

    trackPromise(
      SolicitudesService.getTarjetasSocios()
        .then((response) => {
          var data = JSON.stringify(response.data);

          var jsonData = JSON.parse(data);

          if (jsonData.datos.length > 0) {
            var datos = JSON.parse(JSON.stringify(jsonData.datos));

            this.setState({ tcOriginal: datos });
            for (var i = 0; i < datos.length; i++) {
              var nro = datos[i].numeroTarjeta
              var resultadoNro = nro.substring(0, 4) + "****" + nro.substring(nro.length - 4, nro.length)
              tarjetas.push({                
                value: datos[i].numeroBin,
                numeroTarjeta: datos[i].numeroTarjeta,
                label: datos[i].descripcion + " - " + resultadoNro,
                limiteCompra: datos[i].limiteCompra,
              });
            }

          }
          else {
            Popup.queue(this.notifiPopup("Error", "No cuenta con Tarjetas de Crédito"));
            return;
          }
        }

        ));
    return tarjetas;
  }

  agregarPunto = (valor) => {
    var cant = valor.length / 3
    var puntos = Math.trunc(cant)

    var resultado = ""
    for (var j = 0; j < puntos; j++) {
      var miles = valor.substring(valor.length - 3, valor.length)
      valor = valor.substring(0, valor.length - 3)
      if (resultado === "")
        resultado = miles + resultado
      else
        resultado = miles + "." + resultado

    }
    resultado = valor + resultado


    return resultado;
  };

  selectorValue = (dataFromChild, valores) => {

    var montoNuevo = undefined

    var label = undefined
    var limit = undefined
    var tcNro = undefined
    if (valores != undefined) {
      label = valores.label
      limit = valores.limiteCompra
      tcNro = valores.numeroTarjeta
      var resultado = (Math.trunc(valores.limiteCompra / 1000000) * 1000000)
      montoNuevo = resultado + 1000000
    }
    this.setState({
      tipo: dataFromChild,
      limite: formatoSeparadorMilesValue(limit),
      descripcion: label,
      value: montoNuevo,
      montoLimInf: montoNuevo,
      limiteCompra: limit,
      numeroTarjeta: tcNro,
      monto: montoNuevo
    });
    document.getElementById('monto').value = formatoSeparadorMilesValue(montoNuevo);
  };

  changeRangeValue = (e) => {
    if (e.target.value < this.state.montoLimInf) {
      this.setState({ value: this.state.montoLimInf, monto: this.state.montoLimInf })
      document.getElementById('monto').value = formatoSeparadorMilesValue(this.state.montoLimInf);
      return
    }
    this.setState({ value: e.target.value, monto: e.target.value })
    document.getElementById('monto').value = formatoSeparadorMilesValue(e.target.value);

  }

  onChangeValue = (e) => {
    var numero = e.target.value
    var importe = splitImporte(numero);
    if (importe < this.state.montoLimInf) {
      this.setState({ value: this.state.montoLimInf, monto: this.state.montoLimInf })
      document.getElementById('monto').value = formatoSeparadorMilesValue(this.state.montoLimInf);
      return
    }
    if (importe > this.state.limiteSuperior) {
      this.setState({ value: this.state.limiteSuperior, monto: this.state.limiteSuperior })
      document.getElementById('monto').value = formatoSeparadorMilesValue(this.state.limiteSuperior);
      return
    }
    var resultado = (Math.trunc(importe / 1000000) * 1000000)
    this.setState({ value: resultado, monto: resultado })
    document.getElementById('monto').value = formatoSeparadorMilesValue(resultado);

  }

  phoneSelectorValue = (dataFromChild) => {
    this.setState({
      phoneFormat: dataFromChild,
      telefono: this.formatearPhone(dataFromChild)
    });
  };

  formatearPhone = (valor) => {
    valor = valor.replace("(", "");
    valor = valor.replace(")", "");
    valor = valor.replace("-", "");

    return valor;

  }


  confirmarBtn = () => {
    trackPromise(
      SolicitudesService.confirmarSolicitudAumentoTC(this.state.monto, this.state.tipo, this.state.telefono, this.state.email, this.state.numeroTarjeta)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigo === 0) {
            this.limpiarTodo()
          }
          else {
            Popup.create({
              title: "Solicitud de Aumento de Línea de TC",
              content: jsonData.mensaje,
              buttons: {
                right: [{
                  text: 'Aceptar',
                  className: 'success',
                  action: function () {

                    Popup.close();
                  }
                }]
              }
            });
          }
        }

        ));

  }
  limpiarTodo = () => {
    this.inicializarEstados()
  }

  inicializarEstados = () => {
    this.setState({
      value: 0,
      itemsConfirm: [],
      tcSocio: [],
      tipo: undefined,
      descripcion: undefined,
      limite: undefined,
      telefono: undefined,
      phoneFormat: undefined,
      montoLimInf: undefined,
      email: undefined,
      tcOriginal: undefined,
      limiteCompra: undefined,
      limiteSuperior: 30000000,
    }, this.enableNext
    );

  }

  enableNext() {
    sessionStorage.setItem("msg", "SI");
    window.location.reload();

  }

  calificaTajertaOro(){
    if(this.state.tipo === "54186321" && this.state.monto>=10000000){
      return true;
    }else{
      return false;
    }  
  }

  render() {
    var tarjetas = this.state.tcSocio
    var montoActual = this.state.monto
    return (
      <div className="content-wrapper">
        <ConfirmarOperacionSolicitud
          idModal="idModalConfirm"
          title="Solicitud de aumento de Línea de Crédito de TC"
          items={this.state.itemsConfirm}
          tarjetaOro={this.calificaTajertaOro()}
          confirmarBtn={this.confirmarBtn.bind(this)}
        />
        <Titulo texto="Solicitud de aumento de Línea de Crédito de TC" />
        <section className="content">
          <form id="idTCForm" onSubmit={(e) => {
            e.preventDefault();

          }}>
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  <div className="card">
                    <div className="card-header">
                      <DatosSocio />
                    </div>
                    { tokenActivo === "N" &&
                    <div className="col-12">
                      <div className="card card-aviso-completo">
                    <div className="card-header card-aviso">
                      <h3 className="title-aviso">Estimado Socio:</h3>
                    </div>
                    <div className="card-body">
                      <p>Recuerde que firmar el Contrato Único y gestionar su Token, le permitirá acceder a mayores 
                        beneficios y seguridad en sus transacciones. Le esperamos en cualquiera de nuestras Sucursales.</p>
                    </div>
                    </div>
                    </div>}


                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-7">
                          {<TarjetaCreditoSocio titulo="Tarjeta" presentacion="SELECT" selectorValue={this.selectorValue.bind(this)} itemSelected={this.state.tipo} tarjetas={tarjetas} />}
                        </div>
                        <div className="col-md-5">
                          <div className="row float-right" style={{ paddingLeft: 8, marginRight: -30 }}>
                            {<LimiteTarjetaCredito limite={this.state.limite} />}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            {/* <InputRange
                              minValue={this.state.montoLimInf}
                              value={this.state.value}
                              maxValue={30000000}
                              step={1000000}
                              formatLabel={value => formatoSeparadorMilesValue(value) + " Gs."}
                              onChange={value => this.changeRangeValue(value)} /> */}
                            
                              <Slider

                                value={this.state.value}
                                min={this.state.montoLimInf}
                                max={30000000}
                                step={1000000}
                                valueLabelDisplay="auto"
                                color="primary"
                                valueLabelFormat={value => formatoSeparadorMilesValue(value) + " Gs."}
                                onChange={value => this.changeRangeValue(value)}
                              />
                            
                            <label className="input-label-bold">Monto</label>
                            <input id="monto" name="monto" type="text" placeholder="monto a solicitar"
                              className="form-control input-box" defaultValue={montoActual} style={{ textTransform: "lowercase" }} onBlur={this.onChangeValue} />
                            <label className=" texto-importante">Nuevo Límite de Crédito (Múltiplos de 1.000.000)</label>
                          </div>
                        </div>
                      </div>
                      <CampoNroTelefono label={"Teléfono del contacto"} phoneSelectorValue={this.phoneSelectorValue.bind(this)} phoneSelector={this.state.phoneFormat} />
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label className="input-label-bold">Correo Electrónico</label>
                            <input name="correo" type="mail" placeholder="email" defaultValue={this.state.email} onChange={(val) => {
                              this.setState({ email: val.target.value });
                            }}
                              className="form-control input-box" style={{ textTransform: "lowercase" }} />
                            <span id="erremail"></span>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <MensajeUsuario tipo="INFO"
                            titulo="Pedido sujeto a análisis."
                            mensaje="Consulte su línea de crédito en CU24HS, a partir del quinto día hábil
                          posterior a su fecha de envío.
                          De no variar su línea en ese periodo, contacte al 919 6205 ó 919 6206." />
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="row">
                        <div className="col-lg-10 col-md-6">
                        <label className="input-label-bold-obligatorio float-left">
                        (*) Campos Obligatorios
                    </label>
                        </div>
                        <div className="col-lg-2 col-md-6">
                        <button className="btn btn-cu-primary float-right" onClick={() => this.loadDataConfirm()}>
                      <FontAwesomeIcon icon={faPaperPlane} />  Enviar
                    </button>
                      <a
                        ref={(a) => (this.modalCtrlConfirm = a)}
                        href="#"
                        hidden
                        id="modalCtrlConfirm"
                        data-toggle="modal"
                        data-target="#idModalConfirm"
                      ></a>
                        </div>
                      </div>
                     
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    );
  }
}
